import React from 'react';
import CsapCalculator from './components/CsapCalculator';

function App() {
  return (
    <div className="min-h-screen bg-[#0A1128] flex items-center justify-center">
      <CsapCalculator />
    </div>
  );
}

export default App;